import React, { JSX, useEffect } from "react";

interface LoaderProps {
  isLoading: boolean;
  message?: string;
  children?: JSX.Element | JSX.Element[];
}

export default function Loader({
  isLoading,
  message = "",
  children,
}: LoaderProps) {
  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("isloading");
    }
    return () => {
      document.body.classList.remove("isloading");
    };
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="fixed z-[9998] size-full progress backdrop-blur-[2px] gap-2 flex-col inset-0 bg-black bg-opacity-15 flex justify-center items-center pointer-events-none cursor-progress ">
        <span className="rounded-full border-white block size-8 border-4 border-t-blue-400 animate-spin ease-in-out" />
        {message && (
          <span className="text-black/65 font-semibold">{message}</span>
        )}
      </div>
    );
  }
  return children;
}
